import AddFiltersButton from '@components/FilterV3/components/AddFiltersButton/AddFiltersButton';
import { Box, Stack } from '@mui/material';
import { ReactNode } from 'react';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../modules/translation/TranslationContext';
import { FilterTestIds } from '../../../../../utils/testIds/Filter.testIds';
import { ListScreenFiltersConfig } from '../listScreen.types';

interface ListScreenToolbarProps {
  tabs?: ReactNode;
  toolbarStart?: ReactNode;
  filters?: ListScreenFiltersConfig;
  filterActions?: ReactNode;
}

export function ListScreenToolbar({
  tabs,
  toolbarStart,
  filters,
  filterActions,
}: ListScreenToolbarProps) {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', justifyContent: 'space-between', gap: 2, py: 1.5 }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {tabs}
        {toolbarStart}
      </Box>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.75, flexShrink: 0 }}>
        {filters && (
          <>
            {filters.options.length > 0 && (
              <AddFiltersButton
                label={translate(LangEnum.GLOBAL_FILTER)}
                testId={FilterTestIds.OPEN_ADD_FILTERS_BUTTON}
              />
            )}
            {filters.columnsVisibility}
          </>
        )}
        {filterActions}
      </Stack>
    </Stack>
  );
}
